import { combineReducers } from 'redux';


import pages from './pages';
import filters from './filters';
import cart from './cart';
import auth from './auth';

export default function createRootReducer(routerReducer) {
    return combineReducers({
        router: routerReducer,
        pages,
        filters,
        cart,
        auth,
    });
}
